import React, { createContext, useReducer, useContext, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  messages: [],
  loading: false,
  error: null,
};

const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
const SET_DATA = 'SET_DATA';
const REMOVE_LAST_MESSAGE = 'REMOVE_LAST_MESSAGE';

const chatReducer = (state, action) => {
  switch (action.type) {
    case ADD_NEW_MESSAGE:
      return {
        ...state,
        messages: [action.payload,...state.messages ]?.sort?.((a, b) => new Date(b.createdAt ?? 0) - new Date(a.createdAt ?? 0)),
      };
    case SET_DATA:
        return {
            ...state,
            ...action.payload
        };
    case REMOVE_LAST_MESSAGE:
        return {
            ...state,
            messages: state.messages.slice(1)?.sort?.((a, b) => new Date(a.createdAt ?? 0) - new Date(b.createdAt ?? 0)),
        };
    default:
      return state;
  }
};

const ChatContext = createContext();

export const ChatProvider = ({ children,data }) => {
  const [state, dispatch] = useReducer(chatReducer, {...initialState,...(data??{})});

  const addNewMessage = (message) => {
    dispatch({ type: ADD_NEW_MESSAGE, payload: {...message,id_key: uuidv4(),createdAt:message?.createdAt??new Date().getTime()} });
  };

  const setState = useCallback((data) => {
    dispatch({ type: SET_DATA, payload: data });
  },[]);

  const removeLastMessage = () => {
    dispatch({ type: REMOVE_LAST_MESSAGE });
  }

  return (
    <ChatContext.Provider value={{ state, addNewMessage,setState,removeLastMessage }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  return useContext(ChatContext);
};
